import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable, when } from 'mobx';

import ContentStore from 'stores/Content.store';

import { injectIntl } from 'react-intl';

import messages from './Management.intl';

//styles
import styles from './Management.module.scss';

import { Container } from 'common/components/Layout/Layout';
import PersonBox from './Components/PersonBox/PersonBox';
import { Tabs, Panel } from 'common/components/Tabs/Tabs';
import Shareholders from './Components/Shareholders/Shareholders';

@injectIntl
@observer
export default class Management extends Component {
  management = observable([]);

  async componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);

    when(
      () => ContentStore.isLoaded,
      () => this.management.replace(ContentStore.content.homePageManagement)
    );
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  render() {
    //////
    // Disabled option
    const supervisory = [];
    /*
    const supervisory = PeopleStore.getPeopleByPositionType(
      STATIC_TAXONOMY.POSITION_TYPE.values.SUPERVISORY_BOARD
    );
    */
    //////

    const {
      props: { intl }
    } = this;

    const tabsSettings = {
      padding: '20px 0 0 0',
      showArrowOnDesktop: false,
      showTabsNav: true,
      isMobile: false
    };

    return (
      <Container>
        <div className={styles.SectionWrapper}>
          <div className={styles.Header}>
            <h3 className={styles.HeaderTitle}>
              {intl.formatMessage(messages.headingTitle)}
            </h3>
            <div className={styles.Content}>
              <Tabs {...tabsSettings}>
                <Panel name={intl.formatMessage(messages.headingManagement)}>
                  <div className={styles.PanelContainer}>
                    <div className={styles.PanelColumnWrap}>
                      {this.management.map(el => (
                        <PersonBox
                          key={el.person.id}
                          name={el.person.fullName}
                          status={el.person.position}
                          photo={el.image}
                          description={el.person.description}
                          experience={el.person.professionalAchievements}
                          linkedInLink={el.person.linkedInLink}
                          rolledUp={false}
                        />
                      ))}
                    </div>
                  </div>
                </Panel>
                {supervisory.length > 0 && (
                  <Panel name={intl.formatMessage(messages.headingDirectors)}>
                    {supervisory.map(person => (
                      <PersonBox
                        key={person.id}
                        name={person.fullName}
                        status={person.position}
                        photo={person.homePagePhoto}
                        description={person.description}
                        experience={person.professionalAchievements}
                        linkedInLink={person.linkedInLink}
                        rolledUp={true}
                      />
                    ))}
                  </Panel>
                )}

                <Panel name={intl.formatMessage(messages.headingShareholders)}>
                  <Shareholders />
                </Panel>
              </Tabs>
            </div>
          </div>
        </div>
      </Container>
    );
  }

  setActiveFilter(filter) {
    if (this.state.activeFilter !== filter) {
      this.setState({
        activeFilter: filter
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Management/Management.js